import {BrowserModule} from '@angular/platform-browser';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import {NgModule, Injectable} from '@angular/core';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {LoggedInGuard} from './auth/logged-in-guard.service';
import {AuthService} from './auth/auth.service';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {CallbackModule} from './auth/callback/callback.module';
import {JwtInterceptor} from './auth/jwt.interceptor';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ToastrModule} from 'ngx-toastr';
import {environment} from '../environments/environment';
import {AlarmModule} from './alarm/alarm.module';
import {LandingPageModule} from './landing-page/landing-page.module';
import {HomeModule} from './home/home.module';
import {AngularWebStorageModule, LocalStorageService, SessionStorageService} from 'angular-web-storage';
import {ServiceWorkerModule} from '@angular/service-worker';
import { VivoModule } from './vivo/vivo.module';
import {AppVersionNotifierModule} from './management/app-version/app-version-notifier/app-version-notifier.module';
import { SidebarModule } from './sidebar/sidebar.module';
import { FontAwesomeIconsModule } from './fontawesome-icons.module';
import { EncryptedDataService } from './auth/encrypted-data.service';
import { Observable, from } from 'rxjs';
import { NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { DatepickerI18n } from './shared/datepicker-i18n.service';

@Injectable()
export class ImportTranslateLoader implements TranslateLoader {
  getTranslation(lang: string): Observable<{ [key: string]: string }> {
    return from(import(/* webpackChunkName: "i18n" */ `../assets/i18n/${lang}.json`));
  }
}

/**
 * Main app module. Load other modules and global dependencies.
 */
@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    AppVersionNotifierModule,
    AngularWebStorageModule,
    AlarmModule,
    BrowserAnimationsModule,
    HttpClientModule,
    CallbackModule,
    LandingPageModule,
    HomeModule,
    VivoModule,
    SidebarModule,
    BrowserModule,
    AppRoutingModule,
    FontAwesomeIconsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: ImportTranslateLoader,
        deps: [HttpClient]
      }
    }),
    ToastrModule.forRoot({
      preventDuplicates: false,
      closeButton: true,
      timeOut: 5000,
      extendedTimeOut: 1000,
      progressBar: true
    }),
    ServiceWorkerModule.register('/ngsw-worker.js', {enabled: environment.production})
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true
    },
    LoggedInGuard,
    AuthService,
    EncryptedDataService,
    LocalStorageService,
    SessionStorageService,
    { provide: NgbDatepickerI18n, useClass: DatepickerI18n },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
